import React from 'react';
import EmailActions from './EmailActions';

function LocationStockEmailActions({
  locationId,
  report,
  disabled = false,
  loading = false,
  buttonClassName = 'button small blue',
  successMessage,
  onSent,
  onError,
  onLoadingChange,
}) {
  const locationName = report?.locationName || '';
  const filenameName = String(locationName || 'Location').replace(/[^a-z0-9]+/gi, '_');
  return (
    <EmailActions
      endpoint={locationId && report ? `/locations/${locationId}/location-stock-check/email` : ''}
      templateKey="locationStock"
      templateValues={{
        document: 'Location Stock Check',
        documentNumber: '',
        recipientName: locationName,
        locationName,
      }}
      recipient={report?.locationEmail || ''}
      subject={`Location Stock Check - ${locationName}`.trim()}
      quickTitle="Send Location Stock Check"
      quickPrompt="Send location stock check to:"
      attachmentPdf={`Location_Stock_Check_${filenameName}.pdf`}
      attachmentExcel={`Location_Stock_Check_${filenameName}.xls`}
      disabled={disabled || !locationId || !report}
      loading={loading}
      buttonClassName={buttonClassName}
      successMessage={successMessage}
      onLoadingChange={onLoadingChange}
      onSent={onSent}
      onError={onError}
    />
  );
}

export default LocationStockEmailActions;
